/**
 * BubbleCommon组件得公共文案
 */
import React from 'react';
import { TipsMapType } from '../index';
import { documentCh, documentEh } from './utils';

export const mentionsTips: TipsMapType = {
  en: 'Mentions: Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the Game Store, as well as reviews captured on Social Media through monitor keywords and official accounts.',
  zh: '声量：全网抓取到的玩家帖子和评论数汇总。包括游戏在游戏商店下的所有评论，以及通过监控词和官号在社交媒体上抓取到的评论。',
};
export const accountPostsTips: TipsMapType = {
  en: 'Account Posts: Summary of the number of Account posts on social media.',
  zh: '官号主贴量：在社交媒体获取该游戏官号下的所有主贴内容。',
};

export const engagementTips: TipsMapType = {
  en: (
    <>
      Engagement: Summary of Likes, Comments and Shares of all Post and their
      reviews.（Both Video, Image and Text Post are included）
      <br />
      Engagement = Post ( Likes + Comments +Shares) + Comments ( Likes + replies
      )
    </>
  ),
  zh: (
    <>
      互动量：所有评论内容（主贴&回复）点赞量、评论量、转发量的汇总。（其中主贴包含视频、图片以及文本帖子）
      <br />
      互动量= 主贴的（点赞+评论数+分享）+ 评论的（点赞+回复数）
    </>
  ),
};

export const sentimentTips: TipsMapType = {
  en: 'Sentiment: Sentiment score is to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, with a scale of 1-5. 5 is Very Positive, 4 is Positive, 3 is Neutral, 2 is Negative, 1 is Very Negative.',
  zh: '情感分：情感分是通过NLP算法和情感分析来对每条评论的情感倾向进行打分，分值范围为1-5。5 代表 Very Positive 非常正面的，4 代表 Positive 正面的，3 代表 Neutral 是中性的，2 代表 Negative 负面的，1 代表 Very Negative 非常负面的。',
};

export const nonNegativeTips: TipsMapType = {
  en: 'Non Negative %: The proportion of Positive and Neutral sentiment Reviews in total Reviews (Posts & Comments).',
  zh: '非负情感占比：正面+中性情感声量在总声量中的占比。',
};

export const pcUserScoreTips: TipsMapType = {
  en: "The percentage of positive reviews taken from Steam's official calculation.",
  zh: '数据取自Steam官方计算的正面评论占比数。',
};

export const newPcUserScoreTips: TipsMapType = {
  en: 'Steam Selected Reviews Positive%: Based on all Steam reviews crawled during the selected time period, and the proportion of positive reviews is calculated.',
  zh: 'Steam正面评论百分比：基于所选时段爬取到的全部Steam评论，经过计算得出正面评论占比值。',
};

export const consoleUserScoreTips: TipsMapType = {
  en: "The data is taken from Metacritic's official User Score data.",
  zh: '数据取自 Metacritic 官方的 User Score 数据。',
};

export const googleText: TipsMapType = {
  en: (
    <>
      Lifetime User Score: Within the selected date range, DataBrain take the
      Region/Country's latest User Score, and then average the scores of these
      different Regions/Countries. (Excluding countries that lack Lifetime User
      Score on this day; Filters other than country and date do not take effect)
      <br />
      The countries displayed in Google Play reviews are obtained by crawling
      through the Google Play scores for each language and then mapping the
      language to the country.
      <br />
      <br />
      {documentEh}
    </>
  ),
  zh: (
    <>
      历史累积评分:
      所选日期范围内，取最新有数据的一天，这天中不同国家的LifeTime商店评分值求平均。（不考虑在这天LifeTime商店评分没有值的国家；国家和日期以外其他筛选器不生效）
      <br />
      展示在页面 Google Play的国家应用市场评分，是 DataBrain 通过 Google Play
      的语种爬取评分后，再通过语种映射到国家而获得。
      <br />
      <br />
      {documentCh}
    </>
  ),
};

export const shortGoogleText: TipsMapType = {
  en: (
    <>
      The countries displayed in Google Play reviews are obtained by crawling
      through the Google Play scores for each language and then mapping the
      language to the country.
      <br />
      <br />
      {documentEh}
    </>
  ),
  zh: (
    <>
      Google Play 评论中显示的国家，是通过爬取 Google Play
      各语种评分后，再通过语种映射到国家而获得。
      <br />
      <br />
      {documentCh}
    </>
  ),
};

export const lifeTimeText: TipsMapType = {
  en: "Within the selected date range, DataBrain take the Region/Country's latest User Score, and then average the scores of these different Regions/Countries.",
  zh: '所选日期范围内，取最新有数据的一天，这天中不同国家的历史累计商店评分值求平均。（不考虑在这天历史累计商店评分没有值的国家；国家和日期以外其他筛选器不生效）',
};

export const selectedText: TipsMapType = {
  en: 'Average the score values of added reviews for the selected filter (including Date, Region/Country, Sentiment, and other filters).',
  zh: '所选筛选条件内（包括日期、国家、情感分等其他筛选器），新增评论评分值求平均。',
};

export const feedsNewsTipsText: TipsMapType = {
  en: (
    <>
      News crawling strategy: the crawler will use the game name & game alias to
      pair [news title] instead of [news title + content], the news whose title
      hits the game name will enter this game news database.
    </>
  ),
  zh: (
    <>
      新闻爬取策略：爬虫将使用游戏名&游戏别名去配对【新闻标题】而非【新闻标题+内容】，标题命中游戏名称的新闻将进入本游戏新闻数据库。
    </>
  ),
};
